var modules_e182d482 = {"container":"_1pt5x8j"};
import "../../../assets/C65XM7L5.css";

export { modules_e182d482 as default };
//# sourceMappingURL=Layout.module.less.js.map
